import * as ducks from './index'

export default Object.keys(ducks).reduce((result, duckName) => {
  const { routes } = ducks[duckName]
  if (routes) result[duckName] = routes
  return result
}, {})
